export const CHANNEL_PATH_SPLITTER = '__messenger_channel_splitter__';
